import { Component } from 'opus-angular-seed-core';

@Component({
    template: `
        <div class="heading01 type01">
            <h1>{{ 'templates.Email notifications' | translate }}</h1>
            <a class="btn edit" ng-click="vm.editEmailSendingOptions()">{{ 'templates.Edit e-mail sending options' | translate }}</a>
        </div>
        <manage-templates-filter list="vm.list" default-filter="vm.defaultFilter" filter="vm.filter"/>
        <list-factory-empty list="vm.list" show-add-message="false"></list-factory-empty>
        <div class="well" ng-if="!vm.list.loading && vm.list.items.length">
            <table class="data01" datatable dt-options="vm.DATATABLES">
                <thead>
                    <tr>
                        <th ng-class="vm.list.getSortClass('name')">
                            <a ng-click="vm.list.sortBy('name')">{{ 'template.Notification' | translate }}</a>
                        </th>
                        <th ng-repeat="value in vm.companyLanguages">
                            {{ value }}
                        </th>
                        <th ng-class="vm.list.getSortClass('modifier')">
                            <a ng-click="vm.list.sortBy('modifier')">{{ 'template.Last modified by' | translate }}</a></th>
                        <th ng-class="vm.list.getSortClass('updatedAt')">
                            <a ng-click="vm.list.sortBy('updatedAt')">{{ 'template.Last modification time' | translate }}</a></th>
                        <th>&nbsp;</th>
                    </tr>
                </thead>
                <tbody>
                    <tr ng-repeat="item in vm.list.items">
                        <td>
                            <a ui-sref="authorized.manage.templates.detail({ id: item.id })">{{ item.activeI18n.name }}</a>
                            <span ng-if="item.isIcalIncluded && item.sendIcalFile" class="badge">
                            {{ 'template.Contains iCalendar attachment' | translate }}
                            </span>
                        </td>
                        <td ng-repeat="value in vm.companyLanguages">
                            <span ng-class="item.translationStatusClasses[value]"> </span>
                        </td>
                        <td>{{ item.i18nInCompanyLang.modifier.displayName }}</td>
                        <td>
                            <div ng-if="item.i18nInCompanyLang.updatedBy">
                                {{ vm.MomentService.formatTimeStamp(item.i18nInCompanyLang.updatedAt) }}
                            </div>
                        </td>
                        <td class="actions">
                            <a class="btn view" ng-click="vm.previewEmail(item.i18nInCompanyLang)">{{ 'notification.Preview' | translate }}</a>
                            <a class="btn edit" ui-sref="authorized.manage.templates.detail({ id: item.id })">
                                {{ 'template.Edit' | translate }}
                            </a>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    `
})
export default class {
    constructor (DATATABLES, ListFactory, NotificationResource, MomentService, ModalService, NotificationService,
                 TokenService, lodash, COMPANY_LANGUAGE_ENUM) {
        this.DATATABLES = DATATABLES;
        this.ListFactory = ListFactory;
        this.NotificationResource = NotificationResource;
        this.MomentService = MomentService;
        this.ModalService = ModalService;
        this.NotificationService = NotificationService;
        this.TokenService = TokenService;
        this.COMPANY_LANGUAGE_ENUM = COMPANY_LANGUAGE_ENUM;
    }

    $onInit () {
        this.companyLanguages = this.TokenService.getCompanyLanguages();
        this.defaultFilter = { expand: 'activeI18n,i18nInCompanyLang.modifier,templateI18ns' };
        this.filter = angular.copy(this.defaultFilter);
        this.list = this.ListFactory.createWithoutPagination(this.NotificationResource.templateIndex.bind(this.NotificationResource));
        this.list.fetch(this.defaultFilter).then(() => {
            this.NotificationService.getTranslationStatusClasses(this.list);
        });
    }

    previewEmail (templateI18n) {
        return this.ModalService.open({
            template: '<modals-template-preview template-i18n="vm.templateI18n" class="wrapper" cancel="vm.$uibModalInstance.dismiss()"/>',
            controller ($uibModalInstance) {
                this.$uibModalInstance = $uibModalInstance;
                this.templateI18n = templateI18n;
            }
        });
    }

    editEmailSendingOptions () {
        return this.ModalService.open({
            size: 'large',
            template: `
                <modals-template-edit-sending-options
                    uib-modal-instance="vm.uibModalInstance"
                />
            `,
            controller ($uibModalInstance) {
                this.uibModalInstance = $uibModalInstance;
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/manage/templates/list/index.js